<h1 mat-dialog-title class="text-center title" *ngIf="data.title">{{data.title}}</h1>
<div mat-dialog-content>
  <!-- {{data.message}} -->
  <div *ngIf="imgs.length > 0; else sinImagenes">
    <div *ngFor="let img of imgs" style="margin-bottom: 10px;">
      <img [src]="img" width="100%" style="border: 1px solid #ccc; border-radius: 4px;" />
    </div>
  </div>
  <ng-template #sinImagenes>
    <p class="text-center">No hay imágenes disponibles.</p>
  </ng-template>
</div>
<div mat-dialog-actions class="d-flex justify-content-center">
  <button mat-raised-button (click)="closeConfirmDialog()" class="btn btn-serfor btn-xs color-white">Cerrar Imagen</button>
  <!--<button mat-raised-button (click)="confirmDialog()" cdkFocusInitial color="primary"  >{{data.labelOk}}</button>-->
</div>